import React, { useMemo } from "react";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import {
  formatAudSmart,
  formatCount,
  truncateLabel,
} from "pages/ServiceProvider/SpSetting/AiCreditsUsage/aiUsageChartUtils";
import PlatformAiUsageBreakdownTrendChart from "./PlatformAiUsageBreakdownTrendChart";
import { formatCareSector, mapBySectorForChart } from "./aiUsageOverview.utils";

const PlatformAiUsageBySectorChart = ({
  items = [],
  trends = [],
  loading = false,
  error = "",
  from,
  to,
  granularity = "day",
}) => {
  const mappedItems = useMemo(() => mapBySectorForChart(items), [items]);

  const totals = useMemo(() => {
    const cost = mappedItems.reduce(
      (sum, row) => sum + (Number(row.cost_aud) || 0),
      0
    );
    const tenants = mappedItems.reduce(
      (sum, row) => sum + (Number(row.tenant_count) || 0),
      0
    );
    return { cost, tenants };
  }, [mappedItems]);

  const topSector = [...mappedItems].sort(
    (a, b) => (Number(b.cost_aud) || 0) - (Number(a.cost_aud) || 0)
  )[0];

  return (
    <PlatformAiUsageBreakdownTrendChart
      title="Spend by sector"
      subtitle="NDIS vs aged care vs dual-sector tenants over time"
      icon={HiOutlineOfficeBuilding}
      iconClassName="bg-amber-50 text-amber-600"
      trends={trends}
      keyField="sector_key"
      from={from}
      to={to}
      granularity={granularity}
      loading={loading}
      error={error}
      valueKey="cost_aud"
      topN={4}
      labelFn={(key) => formatCareSector(key) || key}
      metricItems={
        mappedItems.length > 0
          ? [
              { label: "Total spend", value: formatAudSmart(totals.cost) },
              { label: "Active tenants", value: formatCount(totals.tenants) },
              {
                label: "Top sector",
                value: topSector ? truncateLabel(topSector.label, 20) : "—",
              },
            ]
          : []
      }
      emptyTitle="No sector breakdown"
      emptyHint="Sector split appears when tenants have care_sector configured."
    />
  );
};

export default PlatformAiUsageBySectorChart;
